// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
$(document).on("turbo:load", function() {
  $("#teams").on('click', () => $("#webhook_service").val("teams"));
  $("#line").on('click', () => $("#webhook_service").val("line"));
});
